export default __webpack_public_path__ + "static/media/WHO.6009f5d2.png";